const languagesRoutes: any = {
    path: '/l/:token?',
    name: 'language',
    meta: { title: 'navigation.projects-list', notRequiredAuth: true },
    component: () => import('@/views/Language/view/Index/Index.vue'),
    redirect: { name: 'language-dashboard' },
    children: [
        {
            path: 'tj',
            meta: { title: 'navigation.language-module' },
            name: 'translation-jobs',
            component: () => import('@/views/Language/view/TranslationJobs/TranslationJobs.vue'),
        },
        {
            path: 'sg/:stringGroupId',
            meta: { title: 'navigation.language-module' },
            name: 'string-group',
            component: () => import('@/views/Language/view/StringGroup/StringGroup.vue'),
        },
        {
            path: '',
            meta: { title: 'navigation.language-module' },
            name: 'language-dashboard',
            component: () => import('@/views/Language/view/Dashboard/Dashboard.vue'),
        },
    ],
}

export default languagesRoutes
